import { ONBOARDING_GUIDE_STEPS } from '../../../../../services/exports/Constants';

export default {
  title: 'Inicio rápido',
  description: 'Sigue esta guía para llegar al lanzamiento lo antes posible',
  steps: {
    [ONBOARDING_GUIDE_STEPS.Notifications]: 'Preferencia de notificaciones',
    [ONBOARDING_GUIDE_STEPS.OpenTimesAndLocation]: 'Horarios y ubicación',
    [ONBOARDING_GUIDE_STEPS.Identity]: 'Identidad del restaurante',
    [ONBOARDING_GUIDE_STEPS.OrderSettings]: 'Configuración de pedidos',
    [ONBOARDING_GUIDE_STEPS.Menu]: 'Configuración del menú',
    [ONBOARDING_GUIDE_STEPS.Marketing]: 'Marketing y fidelización',
    [ONBOARDING_GUIDE_STEPS.MyStore]: 'Mi tienda',
    [ONBOARDING_GUIDE_STEPS.GoLive]: 'Ir en vivo',
    [ONBOARDING_GUIDE_STEPS.Complete]: 'Completado',
  },
  toasts: {
    failed_to_load_onboarding: 'Error al cargar los pasos de incorporación',
  },
};
